import axios from "axios";

export default {
    namespaced: true,
    state() {
        return {
            allAvailableInventories: [],
            latestDate: "",
            categoriesFromInventories: [],
        };
    },
    getters: {
        allAvailableInventories: (state) => state.allAvailableInventories,
        categoriesFromInventories: (state) => state.categoriesFromInventories,
    },
    actions: {
        async getAllAvailableInventories({ commit }) {
            //fetch list of all available inventories
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .get("/api/get-all-available-inventories")
                    .then((data) => {
                        commit("setAllAvailableInventories", data.data.result);
                        commit("setLatestDate", data.data.latest_date);
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getCategoriesFromInventories({ commit }) {
            //fetch list of all categories from inventories
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .get("/api/get-categories-from-inventories")
                    .then((data) => {
                        commit(
                            "setCategoriesFromInventories",
                            data.data.result
                        );
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
    },
    mutations: {
        setAllAvailableInventories(state, allAvailableInventories) {
            state.allAvailableInventories = allAvailableInventories;
        },
        setLatestDate(state, latestDate) {
            state.latestDate = latestDate;
        },
        setCategoriesFromInventories(state, categoriesFromInventories) {
            state.categoriesFromInventories = categoriesFromInventories;
        },
    },
};
